module.exports = __webpack_public_path__ + "img/icon-dapp-lock.42849253.png";